(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('userMenuV2', ["path", "sideMenuManager", "popupManager", "systemDao", "modals", "feature", "brandInfo", "jira", function (path, sideMenuManager, popupManager, systemDao, modals, feature, brandInfo, jira) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('user-menu-v2').template(),
            scope: { minimized: '=' },
            link: function ($scope, element, attrs) {
                $scope.displayName = '';
                var whiteListForJira = ['avanan'];
                var blackListForProductUpdatesMenu = [
                    'checkpointTheme',
                    'sonicwallTheme',
                    'lastlineTheme'
                ];
                $scope.hideSupportJira = false;
                $scope.showDocumentation = false;
                $scope.showProductUpdates = brandInfo.getBrand() === 'avanan';
                feature.init().then(function () {
                    if (feature.hideSupportJIRA || _(whiteListForJira).findIndex(function (brand) {
                            return brand === brandInfo.getBrand();
                        }) === -1) {
                        $scope.hideSupportJira = true;
                    }
                    if (feature.enableDocumentationMenu) {
                        $scope.showDocumentation = brandInfo.getBrand() === 'avanan';
                        if (_(blackListForProductUpdatesMenu).findIndex(function (theme) {
                                return feature[theme];
                            }) !== -1) {
                            $scope.showDocumentation = false;
                        }
                    }
                    if (_(blackListForProductUpdatesMenu).findIndex(function (theme) {
                            return feature[theme];
                        }) !== -1) {
                        $scope.showProductUpdates = false;
                    }
                });
                $scope.logout = function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    popupManager.current('logoutConfirm');
                };
                $scope.showVersion = function (event) {
                    event.preventDefault();
                    modals.versionInfo();
                };
                $scope.showHelp = function (event) {
                    event.preventDefault();
                    jira.open();
                };
                $scope.$watch(function () {
                    return sideMenuManager.currentUser();
                }, function (currentUser) {
                    var userName = _([
                        currentUser.first_name,
                        currentUser.last_name
                    ]).compact().join(' ');
                    $scope.displayName = userName || currentUser.email;
                    $scope.tooltip = {
                        content: { text: (userName ? userName + '<br />' : '') + currentUser.email },
                        position: {
                            at: 'top center',
                            my: 'bottom center',
                            viewport: true
                        }
                    };
                });
            }
        };
    }]);
}());